import React from 'react'
import { OverSection } from '../styles'
import { TypographyTitle } from 'src/components/common/Typography/typography'
import { useAnimation } from 'src/hook'
import { scaleVariantTitle } from 'src/theme/animations/swipeIn'
import { ContentButton, Description, OltServices } from './styles'
import { ServicesLabels } from 'src/constants'
import Button from 'src/components/common/Button'
import { Link } from 'react-router-dom'
import { ROUTES } from 'src/navigation'
import { useTranslations } from 'src/provider/LocaleProvider'
import { Box } from 'src/components'

export function Services() {
    const { ContentOltServices } = ServicesLabels()
    const t = useTranslations()
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })
    return (
        <OverSection
            paddingTop={['medium', 'medium', 'large', 'titlle']}
            paddingBottom={['medium', 'medium', 'large', 'titlle']}
            ref={ref}
        >
            <TypographyTitle
                variant={'h1'}
                fontSize={['xxxlarge', 'xxxlarge', 'xxxlarge', 'titlle']}
                fontWeight={600}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                {t('services.ourServices')}
            </TypographyTitle>
            <Description
                variant={'h1'}
                fontSize={['xxxsmall', 'xxxsmall', 'medium', 'xxxmedium']}
                fontWeight={400}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                {t('services.intro')}
            </Description>
            <OltServices
                marginTop={'medium'}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                {ContentOltServices.map((services) => (
                    <Box key={services.id}>
                        <Description
                            key={services.id}
                            variant={'h1'}
                            fontSize={[
                                'xxxsmall',
                                'xxxsmall',
                                'xxxsmall',
                                'medium',
                            ]}
                            fontWeight={400}
                            initial="hidden"
                            animate={control}
                            variants={scaleVariantTitle}
                        >
                            {services.title}
                        </Description>
                    </Box>
                ))}
            </OltServices>
            <ContentButton marginTop={'xxmedium'}>
                <Link to={ROUTES.SERVICES}>
                    <Button Content={t('cta.seeMore')} />
                </Link>
            </ContentButton>
        </OverSection>
    )
}
